import { Button } from "@/components/ui/button";
import { PageContainer } from "@/components/layout/PageContainer";

const ProviderProgress = () => {
  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Advanced Progress Monitoring
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Track patient progress with sophisticated analytics and real-time monitoring tools designed to provide comprehensive insights into cognitive health improvements.
        </p>
        <div className="grid gap-8 md:grid-cols-2">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Monitoring Tools</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• Real-time progress tracking</li>
              <li>• Customizable metrics</li>
              <li>• Trend analysis</li>
              <li>• Automated reporting</li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h2 className="text-xl font-semibold mb-4">Analytics Features</h2>
            <ul className="space-y-3 text-gray-600">
              <li>• Predictive analytics</li>
              <li>• Population health insights</li>
              <li>• Custom report generation</li>
              <li>• Data visualization tools</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center">
          <Button size="lg" className="bg-primary hover:bg-primary/90">
            Schedule Demo
          </Button>
        </div>
      </div>
    </PageContainer>
  );
};

export default ProviderProgress;